import { render, staticRenderFns } from "./TiptapBackgroundColor.vue?vue&type=template&id=0b77e97f"
import script from "./TiptapBackgroundColor.vue?vue&type=script&lang=js"
export * from "./TiptapBackgroundColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports